// extracted by mini-css-extract-plugin
module.exports = {"opinion":"Jan","header":"Jap","title":"Jal","icon":"Jaj","list":"Jar","item":"Jat"};